import { useTheme } from '@emotion/react';
import { ShortId } from 'src/ui/components';
import * as S from './styles';

const ErrorBoundaryFallback = () => {
    const theme = useTheme();

    return (
        <S.Container>
            <S.Title>Oops, something went wrong</S.Title>
            <S.Subcontainer>
                <S.Text>
                    An unknown error occurred. Please try refreshing the screen
                    by selecting the button below, or contact support if the
                    issue persists.
                </S.Text>

                <S.Label>Please call support at</S.Label>
                <S.Text>(866) 868-2146</S.Text>
            </S.Subcontainer>

            <S.Button
                theme={theme}
                type="button"
                onClick={() => window.location.reload()}
            >
                Refresh
            </S.Button>
            <ShortId position="absolute" />
        </S.Container>
    );
};

export default ErrorBoundaryFallback;
